import File from '../../../assets/welcomedashboard/apps/file.png'
import { createPortal } from 'react-dom'
import { ImportFiles } from '../dialog/importFiles'
import React from 'react'
import { Button } from '@/components/ui/button'
import { cn } from '@/lib/utils'

interface UploadRecordingsProps {
  className?: string
  onClick: (...args: any[]) => any
  project: any
  showImportDialog: boolean
  handleClose: (...args: any[]) => any
}

export function UploadRecordings(props: UploadRecordingsProps) {
  return (
    <div className={cn('p-6 flex flex-col h-full overflow-y-hidden', props.className)} style={{ maxHeight: '100%' }}>
      <h2 className="mb-1 text-zinc text-[18px]">Upload Recordings</h2>
      <p className="my-4 text-grey-400 font-light">
        Upload your user session recordings as Audio or Video files to be processed.
        <br /> <br />
        Upload up to 10 files, each up to 2GB. Acceptable file types:{' '}
        <span className="font-semibold">MP3, MP4, MP2, WAV, FLAC, PCM, M4A, Ogg, Opus, WebM.</span>
      </p>
      <Button onClick={props.onClick} className="w-full mt-auto">
        <img src={File} className="w-5" alt="" />
        Upload Recordings
      </Button>

      {props.project &&
        props.showImportDialog &&
        createPortal(
          <ImportFiles
            projectId={props?.project?.id}
            projectName={props?.project?.name}
            handleClose={props.handleClose}
          />,
          document.body
        ) as React.ReactPortal}
    </div>
  )
}